import {Hydra} from '../generic/hydra';

import {DossierInterface} from './Dossier';
import {
    DossierNonRecevableRequest as DossierNonRecevableRequestBaseInterface
} from '../../interface/api/DossierNonRecevableRequest';

export type DossierNonRecevableRequestInterface = DossierNonRecevableRequestBaseInterface;

export class DossierNonRecevableRequest extends Hydra implements DossierNonRecevableRequestInterface {

    dossier?: DossierInterface | string | null;

    complement?: string | null;

    sendMail?: boolean | null = true;


    constructor(options: DossierNonRecevableRequestInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
